import React, { useEffect, useRef, useState } from "react";

const GLYPHS = "01<>/{}[]#$%&*+=";

/**
 * Reveals `text` left-to-right with a "decrypting" glyph at the frontier.
 * Falls back to plain text when the user prefers reduced motion.
 */
export default function ScrambleText({ text, delay = 0 }) {
	const [output, setOutput] = useState(text);
	const intervalRef = useRef(null);

	useEffect(() => {
		const reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;
		if (reducedMotion) {
			setOutput(text);
			return;
		}

		let revealed = 0;
		let tick = 0;
		setOutput("");

		intervalRef.current = setInterval(() => {
			tick++;
			if (tick <= delay) return;
			revealed = Math.min(text.length, revealed + 1);
			const settled = text.slice(0, revealed);
			const frontier =
				revealed < text.length
					? GLYPHS[(Math.random() * GLYPHS.length) | 0]
					: "";
			setOutput(settled + frontier);
			if (revealed >= text.length) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		}, 34);

		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, [text, delay]);

	return <span aria-label={text}>{output || " "}</span>;
}
